const UI_STRINGS = {
  EMPTY_FIELD_ERROR_MESSAGE: "This field is required.",
  SPECIAL_CHAR_ERROR_MESSAGE: "Please do not enter the special character.",
  WHITE_SPACE_ERROR_MESSAGE: "Please enter a valid input.",
  PREVIEW_PANEL_DESCRIPTION: "This is a preview block.",
  UNSAVED_WORK_PROMPT:
    "You haven't saved your progress. Hitting refresh or back will lose your work.",
  CANNOT_CONTAIN_MESSAGE: "Please do not enter the special character."
};

export default UI_STRINGS;
